import { useCallback } from 'react';
import { useNavegate } from 'App/hooks';
import { NE_PRINT_LABEL_SOURCE } from 'domains/NuvemEnvioCommons/constants';
import { ordersRoutes } from 'domains/Orders';

type UseGoBackFromLabelPrintingProps = {
  orderId: string;
  source: NE_PRINT_LABEL_SOURCE;
};

type UseGoBackFromLabelPrintingResult = {
  goBack: () => void;
};

export const useGoBackFromLabelPrinting = ({
  orderId,
  source,
}: UseGoBackFromLabelPrintingProps): UseGoBackFromLabelPrintingResult => {
  const { goTo } = useNavegate();

  const goBack = useCallback(() => {
    if (source === NE_PRINT_LABEL_SOURCE.ORDER_DETAILS && orderId) {
      goTo(ordersRoutes.orderDetails.replace(':id', orderId));
      return;
    }

    goTo(ordersRoutes.orderList);
  }, [goTo, source, orderId]);

  return { goBack };
};
